import React from 'react'
import { Controller } from 'react-hook-form'
import ReactSelect, { createFilter } from 'react-select'

import { Input } from '@chakra-ui/react'
import FieldWrapper from '../FieldWrapper/FieldWrapper'

import CustomMenuList from './CustomMenuList'
import CustomOption from './CustomOption'
import { isNullish } from '@/utils/helper'
import VirtualizeMenuList from './VirtualizeMenuList'

const Select = ({
  name,
  options = [],
  allOptions = [],
  disabled,
  isMulti = false,
  isRequired = true,
  defaultValue = '',
  extraOnChange = () => {},
  isClearable = true,
  ...rest
}) => {
  return (
    <Controller
      name={name}
      render={({ field: { onChange, onBlur, value, ref }, fieldState: { error } }) => {
        const isValidObject = typeof value === 'object' && value?.name && value?._id && !isMulti

        const selectedOptionValue = isValidObject ? value._id : value
        const selectedOption = options.filter((option) =>
          isMulti && Array.isArray(selectedOptionValue)
            ? selectedOptionValue.includes(option?.value)
            : option?.value === selectedOptionValue
        )

        const tooltip = selectedOption.map((option) => option?.label || '').join(',')

        return (
          <FieldWrapper name={name} error={error} tooltip={tooltip} isRequired={isRequired} {...rest}>
            {isValidObject && disabled && <Input value={value?.name || ''} disabled />}
            {(!isValidObject || !disabled) && (
              <ReactSelect
                ref={ref}
                isMulti={isMulti}
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  container: () => ({
                    flex: 1,
                  }),
                  control: (base, { isDisabled }) => {
                    let bgColor = 'white'
                    if ((isNullish(value) || value === '') && isRequired) {
                      bgColor = 'yellow'
                    }

                    if (isDisabled) {
                      bgColor = 'hsl(0, 0%, 95%)'
                    }
                    return {
                      ...base,
                      backgroundColor: bgColor,
                      borderColor: '#E2E8F0',
                    }
                  },
                  singleValue: (base) => ({
                    ...base,
                    color: 'hsl(0, 0%, 50%)',
                  }),
                  multiValueRemove: (base, state) => {
                    return state.isDisabled ? { ...base, display: 'none' } : base
                  },
                }}
                // filterOption={createFilter({ ignoreAccents: false })}
                options={options}
                value={selectedOption}
                onChange={(option) => {
                  if (disabled) {
                    return
                  }
                  if (isMulti && Array.isArray(option)) {
                    onChange(option.map((v) => v.value))
                    extraOnChange(option.map((v) => v.value))

                    return
                  }
                  if (!option || option === null) {
                    onChange('')
                    extraOnChange('')

                    return
                  } else {
                    onChange(option.value)
                    extraOnChange(option.value)

                    return
                  }
                }}
                onFocus={() => {
                  const errorElement = document.getElementById(name)
                  if (errorElement) {
                    errorElement.scrollIntoView({
                      behavior: `smooth`,
                      block: 'center',
                    })
                  }
                }}
                onBlur={onBlur}
                components={{ Option: CustomOption, MenuList: CustomMenuList }}
                isDisabled={disabled}
                isClearable={isClearable && !disabled}
                menuPortalTarget={document.body}
              />
            )}
          </FieldWrapper>
        )
      }}
    />
  )
}

export default Select
